/**
 * Enum-like object representing the archived status of a supplier customer.
 * Active: false - The customer is active.
 * Archived: true - The customer is archived.
 */
export const SupplierCustomerArchived = {
  Active: 'false',
  Archived: 'true'
};
